import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import { areasTitles as titles } from "consts/titulos-de-tablas";
import styles from "styles/pages/Pages.module.scss";
import { useService } from "components/route/ServiceRoute";
import Filters from "components/Filters";
import XGrid from "components/UI/Grid/XGrid";
import FilterAltOffRoundedIcon from '@mui/icons-material/FilterAltOffRounded';
import { RNHZonaGet } from "services/services-mia/RNHZonaGet";
import { RNHAreaGet } from "services/services-mia/RNHAreaGet";

export default function AreasSalud() {
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);
    const [zonas, setZonas] = useState([]);
    const [modalDetails, setModalDetails] = useState({ isOpen: false });
    const [loading, setLoading] = useState(false);
    const [areas, setAreas] = useState([]);
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
    const { service } = useService();

    const formik = useFormik({
        initialValues: {
            zonaId: "",
        },
        onSubmit: (values) => {
            getAreas(values)
        },
    })
    const resetForm = () => {
        formik.setFieldValue("zonaId", "");
        getAreas({})
    };

    const getAreas = async (data = { zonaId: null }) => {
        setAreas([]);
        setLoading(true);
        const filter = await RNHZonaGet(credentials);
        setZonas(filter);
        const result = await RNHAreaGet(credentials, data);
        const newRows = result[0]?.rnhAreaId ? result?.map((data) => {
            return {
                id: data.rnhAreaId,
                name: data.rnhAreaNombre,
                cod: data.rnhAreaCod,
                zonaName: data.rnhZonaNombre,
                zonaCod: data.rnhZonaCod,
            };
        }) : []
        setAreas(newRows);
        setLoading(false);
    }
    const closeModal = () => {
        setModalDetails({ isOpen: false });
    };
    const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };

    useEffect(() => {
        getAreas()
    }, [])
    useEffect(() => {
        setRoute({
            wordKey: `Áreas - Programa Salud RN`
        })
    }, [service.servicioNombre, setRoute])
    return (
        <main className={styles.main}>
            <Modal open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal}>
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <UpdateModal
                        user={rowSelected.row}
                        updateList={getAreas}
                        closeModal={closeModal}
                        filtro={zonas}
                    />
                )}
                {modalDetails.procede === ACTIONS.EXPORT && (
                    <DeleteModal
                        user={rowSelected.row}
                        servicio={service}
                        updateList={getAreas}
                        closeModal={closeModal}
                        setterRowSelected={setRowSelected}
                        filtro={zonas}
                    />
                )}
                {modalDetails.procede === ACTIONS.INSERT && (
                    <InsertModal
                        servicio={service}
                        updateList={getAreas}
                        closeModal={closeModal}
                        filtro={zonas}
                    />
                )}
            </Modal>
            <div className={styles["filters-actions"]}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Filters
                        formik={formik}
                        inputsRender={
                            [
                                { type: "select", name: "zonaId", label: "Zona", disabled: false, options: zonas, firtsOptionKey: "rnhZonaId", firstOptionName: "rnhZonaNombre", firstOptionValue: "rnhZonaId" },
                            ]
                        }
                        disabled={loading}
                    />
                    <HeaderButton text={"Borrar filtros"} onClick={() => resetForm()} disabled={loading} ><FilterAltOffRoundedIcon /></HeaderButton>
                </div>
                <Buttons>
                    <HeaderButton
                        text={"Actualizar"}
                        onClick={() => { getAreas() }}
                        disabled={rowSelected.row.id || false}
                    >
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text={"Nueva area"}
                        handleClick={handleClick}
                        data={{
                            title: "Nueva area",
                            procede: ACTIONS.INSERT
                        }}
                        disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
                    >
                        <Add />
                    </HeaderButton>
                    <HeaderButton
                        text={"Modificar area"}
                        handleClick={handleClick}
                        data={{
                            title: "Modificar area",
                            procede: ACTIONS.UPDATE
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <EditOutlined />
                    </HeaderButton>
                    <HeaderButton
                        text={"Eliminar area"}
                        handleClick={handleClick}
                        data={{
                            title: "Eliminar area",
                            procede: ACTIONS.EXPORT
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <DeleteOutlineRoundedIcon />
                    </HeaderButton>
                </Buttons>
            </div>
            <div className={styles.container}>
                <XGrid
                    rows={areas}
                    titles={titles}
                    loading={loading}
                    secondarySelected={rowSelected}
                    setSecondarySelected={setRowSelected}
                />
            </div>
        </main>
    );
}